module.exports = __webpack_public_path__ + "static/media/poster.4800882f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/poster.jpg
// module id = 110
// module chunks = 0